import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { ToastrService } from 'ngx-toastr';
import { Observable, forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { TrabalhadorEstrangeiroDTO } from './trabalhadorEstrangeiroDTO';
import { TrabalhadorEstrangeiroAba5Service } from '../../service/dados-trabalhar-estrangeiro-aba5/dados-trabalhar-estrangeiro-aba5.service';
import { EnumService } from 'app/service/enum/enum';
import { Enum } from 'app/model/enum';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Component({
  selector: 'app-recadastramento-aba5',
  templateUrl: './recadastramento-aba5.component.html',
  styleUrls: ['./recadastramento-aba5.component.sass']
})
export class RecadastramentoAba5Component implements OnInit {
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  @ViewChild('fileInputEstrangeiro') fileInputEstrangeiro!: ElementRef;

  form: FormGroup;
  isLoadingSpinner: boolean = true;
  user: DadosPessoaisAba1Response = null;
  arquivoEnviadoEstrangeiro: boolean;
  arquivoSelecionadoEstrangeiro: File;

  dataChegadaBrasil: Date;
  classificacaoCondicacaoIngresso: number;
  casadoComBrasileiro: string;

  existDiffDataChegadaBrasil: boolean = false;

  isLoading: boolean = true;
  isInfoImportantVisible: boolean = true;
  estrangeiro: boolean = false;
  condicaoIngressoEstrangeiro: Enum[];
  dataChegadaBrasilOriginal: string;
  classificacaoCondicacaoIngressoOriginal: Enum[];
  casadoComBrasileiroOriginal: string;
  filhosBrasileirosOriginal: string;
  existDiffAnexo: boolean = true;
  isAnexo: boolean
  temAnexoConst: boolean
  naoTemMudanca: boolean
  constructor(
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private enumService: EnumService,
    private trabalhadorEstrangeiroAba5Service: TrabalhadorEstrangeiroAba5Service) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.form = this.formBuilder.group({
      dataChegadaBrasil: ['', [Validators.required]],
      classificacaoCondicacaoIngresso: ['', [Validators.required]],
      casadoComBrasileiro: ['', [Validators.required]],
      filhosBrasileiros: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.processarTrabalharEstrangeiro()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
      this.isInfoImportantVisible = true
    }
  }

  private processarTrabalharEstrangeiro(): void {

    this.isLoadingSpinner = true;
    const estrangeiro$: Observable<TrabalhadorEstrangeiroDTO> = this.getTrabalhadorEstrangeiro();

    const ingressoCondicaoEstrangeiro$: Observable<Enum[]> = this.getCondicaoIngressoEstrangeiro();
    //const tipoLogradouro$: Observable<Enum[]> = this.buscarTipoLogradouro();
    forkJoin([estrangeiro$, ingressoCondicaoEstrangeiro$])
      .pipe(finalize(() => this.isLoadingSpinner = false))
      .subscribe(
        ([estrangeiro, ingressoCondicaoEstrangeiro]) => {
          // Manipular os dados do endereço e UFs aqui
          //this.buscarTipoLogradouro()
          //this.buscarMunicipio();
          this.atualizarFormulario(estrangeiro, ingressoCondicaoEstrangeiro);

        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }

  private getTrabalhadorEstrangeiro(): Observable<TrabalhadorEstrangeiroDTO> {
    return this.trabalhadorEstrangeiroAba5Service.getTrabalhadorEstrangeiro();
  }


  private atualizarFormulario(trabalhadorEstrangeiro: TrabalhadorEstrangeiroDTO, ingressoCondicaoEstrangeiro): void {
    this.dataChegadaBrasilOriginal = trabalhadorEstrangeiro.dataChegadaBrasil
    let dataChegadaBrasil = trabalhadorEstrangeiro.dataChegadaBrasil !== null ? trabalhadorEstrangeiro.dataChegadaBrasil.split('/') : '';
    this.estrangeiro = trabalhadorEstrangeiro.estrangeiro
    this.classificacaoCondicacaoIngressoOriginal = trabalhadorEstrangeiro.classificacaoCondicacaoIngresso
    this.arquivoEnviadoEstrangeiro = trabalhadorEstrangeiro.anexoCondicaoIngressoEstrangeiro
    this.temAnexoConst = trabalhadorEstrangeiro.anexoCondicaoIngressoEstrangeiro

    this.casadoComBrasileiroOriginal = trabalhadorEstrangeiro.casadoComBrasileiro
    this.filhosBrasileirosOriginal = trabalhadorEstrangeiro.filhosBrasileiros

    if (trabalhadorEstrangeiro.dataChegadaBrasil != null && trabalhadorEstrangeiro.dataChegadaBrasil != '') {
      this.form.patchValue({
        dataChegadaBrasil: new Date(+dataChegadaBrasil[2], +dataChegadaBrasil[1] - 1, +dataChegadaBrasil[0]),
      });
    } else {
      this.form.patchValue({
        dataChegadaBrasil: null,
      });
    }

    this.form.patchValue({
      classificacaoCondicacaoIngresso: trabalhadorEstrangeiro.classificacaoCondicacaoIngresso,
      casadoComBrasileiro: trabalhadorEstrangeiro.casadoComBrasileiro,
      filhosBrasileiros: trabalhadorEstrangeiro.filhosBrasileiros,
    });
    //this.form.get('dataChegadaBrasil').setValue(dataFormatada)
    this.condicaoIngressoEstrangeiro = ingressoCondicaoEstrangeiro
  }
  formatarData(data: string): string {

    const [ano, mes, dia] = data.split('-');
    return `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${ano}`;
  }
  private getCondicaoIngressoEstrangeiro(): Observable<Enum[]> {
    return this.enumService.buscarCondicaoIngressoEstrangeiro();
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  onArquivoExcluidoEstrangeiro(mensagem) {
    if (mensagem) {
      this.toasterService.success('Arquivo excluído com sucesso');
      this.arquivoEnviadoEstrangeiro = false
    } else {
      this.arquivoEnviadoEstrangeiro = false
    }

    // const input = document.getElementById('input-file-estrangeiro') as HTMLInputElement;
    // if (mensagem) {
    //   this.trabalhadorEstrangeiroAba5Service.deletarComprovanteEstrangeiro().subscribe(resp => {
    //     this.toasterService.success('Arquivo excluído com sucesso');
    //     this.arquivoEnviadoEstrangeiro = false
    //   }, error => {
    //     this.toasterService.error('Erro ao excluir comprovante');
    //   });
    // } else {
    //   this.arquivoEnviadoEstrangeiro = false
    //   this.arquivoSelecionadoEstrangeiro = null;
    //   input.value = '';

    // }
  }

  checkDiffAnexo() {
    if (this.temAnexoConst && this.arquivoEnviadoEstrangeiro) {
      this.isAnexo = true
      this.existDiffAnexo = true

      return true

    } else {
      this.isAnexo = false
      this.existDiffAnexo = false
      return false
    }
  }

  enviarAnexoEstrangeiro() {
    if (this.arquivoSelecionadoEstrangeiro) {
      this.toasterService.info('Enviando arquivo. Por favor, aguarde.');
      this.trabalhadorEstrangeiroAba5Service.uploadComprovanteEstrangeiro(this.arquivoSelecionadoEstrangeiro).subscribe(
        (response) => {
          this.toasterService.success('Arquivo enviado');
          this.arquivoEnviadoEstrangeiro = true
          this.existDiffAnexo = true
          this.temAnexoConst = true
          this.fileInputEstrangeiro.nativeElement.value = '';
        },
        (error) => {
          this.fileInputEstrangeiro.nativeElement.value = '';
          this.arquivoEnviadoEstrangeiro = false
          if (error.status == 422) {
            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
          } else {
            this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`);
          }
          this.onArquivoExcluidoEstrangeiro(false)

        }
      );
    }
  }

  onArquivoSelecionado(event: any) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
      this.arquivoSelecionadoEstrangeiro = file;
      this.enviarAnexoEstrangeiro();

    }
    else {
      this.arquivoSelecionadoEstrangeiro = null;

      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
      }
      this.onArquivoExcluidoEstrangeiro(false)
    }

  }

  visualizarComprovanteEstrangeiro(): void {
    this.trabalhadorEstrangeiroAba5Service.getVisualizarComprovante().subscribe((response: Blob) => {
      const fileName = 'Comprovante Trabalhador Estrangeiro';
      const fileType = this.getFileTypeFromBlob(response);
      if (fileType === null) {
        return;
      }

      const blob = new Blob([response], { type: fileType });
      // Inicia o download do arquivo
      saveAs(blob, fileName + '.' + fileType);
    }, error => {
      this.toasterService.warning('Erro ao fazer o download do arquivo');
    });
  }

  private getFileTypeFromBlob(blob: Blob): string | null {
    if (blob.type) {
      const contentType = blob.type.toLowerCase();
      if (contentType.includes('pdf')) {
        return 'pdf';
      } else if (contentType.includes('jpeg') || contentType.includes('jpg')) {
        return 'jpeg';
      } else if (contentType.includes('png')) {
        return 'png';
      }
    }
    return null;
  }

  extractFileName(contentDispositionHeader: string): string {
    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(contentDispositionHeader);
    if (matches != null && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }
    return '';
  }

  extractFileExtension(fileName: string): string {
    const fileExtensionRegex = /(?:\.([^.]+))?$/;
    const matches = fileExtensionRegex.exec(fileName);
    if (matches != null && matches[1]) {
      return matches[1].toLowerCase();
    }
    return '';
  }
  checagens() {

    // Crie uma instância de DatePipe
    const datePipe = new DatePipe('en-US');

    // Formate a data de chegada ao Brasil no formato desejado
    const dataChegadaFormatada = datePipe.transform(this.form.value.dataChegadaBrasil, 'dd/MM/yyyy');

    if (this.dataChegadaBrasilOriginal != dataChegadaFormatada) {
      this.onArquivoExcluidoEstrangeiro(false)
      this.existDiffAnexo = false;
    } else if (this.classificacaoCondicacaoIngressoOriginal != this.form.value.classificacaoCondicacaoIngresso) {
      this.onArquivoExcluidoEstrangeiro(false)
      this.existDiffAnexo = false;
    } else if (this.casadoComBrasileiroOriginal != this.form.value.casadoComBrasileiro) {
      this.onArquivoExcluidoEstrangeiro(false)
      this.existDiffAnexo = false;
    } else if (this.filhosBrasileirosOriginal != this.form.value.filhosBrasileiros) {
      this.onArquivoExcluidoEstrangeiro(false)
      this.existDiffAnexo = false;
    } else {
      // Se nenhum dos campos teve mudança, executar o bloco de código abaixo:
      this.existDiffAnexo = true;
      this.arquivoEnviadoEstrangeiro = true
    }
    //this.arquivoEnviadoEstrangeiro = true
  }

  checkDataChegadaAoBrasil() {
    // Crie uma instância de DatePipe
    const datePipe = new DatePipe('en-US');

    // Formate a data de chegada ao Brasil no formato desejado
    const dataChegadaFormatada = datePipe.transform(this.form.value.dataChegadaBrasil, 'dd/MM/yyyy');
    if (this.dataChegadaBrasilOriginal != dataChegadaFormatada) {
      
      return true
    } else {
      return false
    }
  }

  checkClassificacaoCondicaoIngresso() {
    if (this.classificacaoCondicacaoIngressoOriginal != this.form.value.classificacaoCondicacaoIngresso) {
      this.onArquivoExcluidoEstrangeiro(false)

      return true
    } else {
      return false
    }
  }

  checkCasadoBrasileiro() {
    if (this.casadoComBrasileiroOriginal != this.form.value.casadoComBrasileiro) {
      this.onArquivoExcluidoEstrangeiro(false)

      return true
    } else {
      return false
    }
  }

  checkTemFilhosBrasileiros() {
    if (this.filhosBrasileirosOriginal != this.form.value.filhosBrasileiros) {
      this.onArquivoExcluidoEstrangeiro(false)

      return true
    } else {
      return false
    }
  }

  formatarDataEnvioBackend(data: string): string {
    const [dia, mes, ano] = data.split('/');
    const dataHoraFormatada = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}T03:00:00.000+00:00`;
    return dataHoraFormatada;
  }

  atualizarTrabalhadorEstrangeiro() {
    const body = {
      casadoComBrasileiro: this.form.value.casadoComBrasileiro,
      classificacaoCondicacaoIngresso: this.form.value.classificacaoCondicacaoIngresso,
      filhosBrasileiros: this.form.value.filhosBrasileiros,
      dataChegadaBrasil: moment(this.form.controls['dataChegadaBrasil'].value).format('DD/MM/YYYY'),
    }

    if (this.estrangeiro) {
      // Adiciona os validadores obrigatórios somente se o formulário for para estrangeiro


      // Verifica se os arquivos foram selecionados
      if (this.checkDataChegadaAoBrasil()) {
        if (!this.arquivoSelecionadoEstrangeiro) {
          this.existDiffAnexo = false
          this.toasterService.warning('Atenção: Anexo do comprovante de ingresso é obrigatório!');
          return;
        }
      }

      if (this.checkClassificacaoCondicaoIngresso()) {
        if (!this.arquivoSelecionadoEstrangeiro) {
          this.existDiffAnexo = false
          this.toasterService.warning('Atenção: Anexo do comprovante de ingresso é obrigatório!');

          return;
        }
      }

      if (this.checkCasadoBrasileiro()) {
        if (!this.arquivoSelecionadoEstrangeiro) {
          this.existDiffAnexo = false
          this.toasterService.warning('Atenção: Anexo do comprovante de ingresso é obrigatório!');

          return;
        }
      }

      if (this.checkTemFilhosBrasileiros()) {
        if (!this.arquivoSelecionadoEstrangeiro) {
          this.existDiffAnexo = false
          this.toasterService.warning('Atenção: Anexo do comprovante de ingresso é obrigatório!');

          return;
        }
      }
      if (!this.checkDiffAnexo() && !this.arquivoSelecionadoEstrangeiro) {
        this.toasterService.warning('Atenção: Anexo do comprovante de ingresso é obrigatório!');

        return;
      }

      // Atualiza a validade do formulário somente após a verificação dos arquivos

      if (this.form.valid) {
        // Lógica para enviar os dados do formulário
        this.trabalhadorEstrangeiroAba5Service.salvarDadosTrabalhadorEstrangeiro(body).subscribe(
          (response) => {
            this.toasterService.success('Dados atualizados com sucesso');
            this.dadosSalvos.emit();
            this.formularioSalvo.emit();
          },
          (error) => {
            console.error('Erro ao atualizar os dados', error);
          }
        );
      } else {
        this.toasterService.warning('Atenção: Todos os campos marcados com (*) são obrigatórios!');
      }
    } else {
      this.form.get('dataChegadaBrasil').clearValidators();
      this.form.get('classificacaoCondicacaoIngresso').clearValidators();
      this.form.get('casadoComBrasileiro').clearValidators();
      this.form.get('filhosBrasileiros').clearValidators();

      this.form.get('classificacaoCondicacaoIngresso').updateValueAndValidity();
      this.form.get('casadoComBrasileiro').updateValueAndValidity();
      this.form.get('filhosBrasileiros').updateValueAndValidity();
      this.form.get('dataChegadaBrasil').updateValueAndValidity();
      this.avancaParaProximoTab()
    }
  }

  avancaParaProximoTab() {
    this.dadosSalvos.emit()

  }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

}
